import React, {useState} from 'react';

import "./TrainingTopicCapture.css";
import {LeftLabelTextInput} from "../../../common/input/left-label-text-input/LeftLabelTextInput";
import {StandardButton} from "../../../common/button/standard-button/StandardButton";
import {LeftLabelToggle} from "../../../common/input/left-label-toggle/LeftLabelToggle";
import {ListItem} from "../../../common/list/list-item/ListItem";
import {ListTextInput} from "../../../common/list/list-text-input/ListTextInput";
import {createTrainingModule, updateTrainingModule} from "../../../../services/TrainingModuleService";

export const TrainingTopicCapture = ({context, navigateTo, navigateBack, setSpinnerText, showToaster}) => {

    const [externalReference] = useState(context.selectedTrainingTopic ? context.selectedTrainingTopic.externalReference : null);
    const [trainingModule, setTrainingModule] = useState(context.selectedTrainingTopic ? context.selectedTrainingTopic.trainingModule : null);
    const [trainingSubModuleList, setTrainingSubModuleList] = useState(context.selectedTrainingTopic ? context.selectedTrainingTopic.trainingSubModuleList : []);
    const [active, setActive] = useState(context.selectedTrainingTopic ? context.selectedTrainingTopic.active : false);
    const [newSubModule, setNewSubModule] = useState("");

    const handleAddSubModuleClick = () => {
        setTrainingSubModuleList((prevState) => ([...prevState, newSubModule]));
        setNewSubModule("");
    }

    const handleDeleteSubModuleClick = (index) => {
        const copyOfTrainingSubModuleList = [...trainingSubModuleList];
        copyOfTrainingSubModuleList.splice(index, 1);
        setTrainingSubModuleList([...copyOfTrainingSubModuleList]);
    }

    const handleClick = async () => {
        const trainingModuleToBeSaved = {externalReference, trainingModule, trainingSubModuleList, active};
        if (null === externalReference) {
            setSpinnerText("Creating Training Module");
            const response = await createTrainingModule(context.username, trainingModuleToBeSaved);
            handleResponse(response);
        } else {
            setSpinnerText("Updating Training Module");
            const response = await updateTrainingModule(context.username, trainingModuleToBeSaved);
            handleResponse(response);
        }
    }

    const handleResponse = ([data, error]) => {
        if (data) {
            showToaster(data);
            if (data.responseStatus === "Success") {
                navigateTo("trainingTopicTable");
            }
            setSpinnerText(null);
        } else {
            showToaster({
                responseStatus: "Error",
                responseMessage: error.message,
            });
            setSpinnerText(null);
        }
    }

    const listItems = trainingSubModuleList.map((trainingModule, index) => {
        return <ListItem key={index} item={trainingModule} onDeleteClick={() => {
            handleDeleteSubModuleClick(index)
        }}/>
    });

    return (
        <div className="training-topic-capture-container">
            <div className="training-topic-capture-form-container">
                <LeftLabelTextInput labelText="Training Module:" defaultValue={trainingModule}
                                    handleChange={({target}) => {
                                        setTrainingModule(target.value)
                                    }}/>
                <LeftLabelToggle labelText="Active:" active={active} setActive={setActive}/>
                <ListTextInput label="Training Sub Modules:" value={newSubModule} setValue={setNewSubModule} handleAddClick={handleAddSubModuleClick} disabled={newSubModule === ""}/>
                <div className="training-topic-capture-list-container">
                    {listItems}
                </div>
            </div>
            <div className="training-topic-capture-button-container">
                <StandardButton text={context.selectedTrainingTopic ? "Update Training Topic" : "Add Training Topic"}
                                onClick={handleClick}/>
                <StandardButton text="Back" onClick={navigateBack}/>
            </div>
        </div>
    );
}
